import {useUserConfig} from "#app/contexts/useUserConfig";
import {useContacts} from "#app/contexts/useContacts";
import {DeepPartial} from "redux";

type UserInfoType = {
    data: {
        id: string
        email: string
        first_name: string
        configs: { id: number, key: string, value: string }[]
        contacts: { id: number, first_name: '' }[]
    }
}

export type UserWrapperType = {
    info: DeepPartial<UserInfoType>
    config: ReturnType<typeof useUserConfig>
    contacts: ReturnType<typeof useContacts>
}

export const useUserContext = (userInfo: UserInfoType): UserWrapperType => {

    let info = userInfo
    let config = Object(useUserConfig(userInfo.data.configs))
    let contacts = useContacts(userInfo.data.contacts)

    return {
        info,
        config,
        contacts,
    }
}
